var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-card-title',[_vm._v(_vm._s(_vm.title))])],1),_c('b-card-body',[_c('smart-users-map',{attrs:{"map-height":500}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }